import { getSubscriberStatus } from 'utils/common';
import { SubscriberStatus } from 'utils/constants';

export const useUserStatus = (currentUser, emailAddress, userId) => {
  const loggedIn = !!currentUser;
  const guestPlayer = !loggedIn && emailAddress && userId;
  const freeSubscriber =
    loggedIn && getSubscriberStatus(currentUser) === SubscriberStatus.FREEMIUM;
  const nonSubscriber =
    loggedIn &&
    getSubscriberStatus(currentUser) === SubscriberStatus.NON_SUBSCRIBER;

  return { loggedIn, guestPlayer, freeSubscriber, nonSubscriber };
};
